/**
 * @generated SignedSource<<b141bb9d8e1e4bfef49d45b2a01de934>>
 * @relayHash e4985c5c5e4ad05f5b2bfe5f68c3c5c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8df3fb34f965fe9185c2f265cfa7b73e8fbbceb9fda35df8c0891b1ada68accc

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardQuery } from './src_jiraBusinessBoardQuery.graphql';

import isUsingNewCreate_provider from '@atlassian/jira-relay-provider/src/mbw-67-board-issue-create.relayprovider';
import withMergedWorkflows_provider from '@atlassian/jira-relay-provider/src/merge-board-workflows.relayprovider';
import isBusinessRelayBoardWorkflowEditingEnabled_provider from '@atlassian/jira-relay-provider/src/relay-board-workflow-editing.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8df3fb34f965fe9185c2f265cfa7b73e8fbbceb9fda35df8c0891b1ada68accc",
    "metadata": {},
    "name": "src_jiraBusinessBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcmbw67boardissuecreaterelayprovider": isUsingNewCreate_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcrelayboardworkfloweditingrelayprovider": isBusinessRelayBoardWorkflowEditingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": withMergedWorkflows_provider
    }
  }
};

export default node;
